import { EmailTemplate } from '@customTypes/Entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store';

export type EmailTemplatesState = {
  selected: Array<number>;
  query: string;
  names: { [key: number]: string };
};

const initialState: EmailTemplatesState = {
  selected: [],
  query: '',
  names: {},
};

export const emailTemplatesSlice = createSlice({
  name: 'email-templates',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    check: (state, action: PayloadAction<EmailTemplate>) => {
      state.selected = state.selected.concat(action.payload.id);
      state.names[action.payload.id] = action.payload.name;
    },
    uncheck: (state, action: PayloadAction<number>) => {
      state.selected = state.selected.filter((s) => s !== action.payload);
      delete state.names[action.payload];
    },
    checkAll: (state, action: PayloadAction<EmailTemplate[]>) => {
      state.selected = [];
      state.selected = state.selected.concat(action.payload.map((emailT) => emailT.id));
      action.payload.forEach((emailT) => (state.names[emailT.id] = emailT.name));
    },
    uncheckAll: (state) => {
      state.selected = [];
      state.names = {};
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
  },
});

export const { check, uncheck, checkAll, uncheckAll, setQuery } = emailTemplatesSlice.actions;

export const getSelectedEmailTemplates = (state: RootState) => state.emailTemplates.selected;

export const getSelectedNamedEmailTemplates = (state: RootState) =>
  Object.entries(state.emailTemplates.names).map(([k, v]) => ({
    id: Number(k),
    name: v,
  }));

export const getEmailTemplatesQuery = (state: RootState) => state.emailTemplates.query;

export default emailTemplatesSlice.reducer;
